import active_users from "../../assets/pl/active-users.webp";
import chapter from "../../assets/pl/chapter.webp";
import company from "../../assets/pl/company.webp";
import courses from "../../assets/pl/courses.webp";
import edit_course from "../../assets/pl/editCourse.webp";
import emails from "../../assets/pl/emails.webp";
import jobss from "../../assets/pl/job_2.webp";
import login from "../../assets/pl/login.webp";
import newsletter from "../../assets/pl/newsletter.webp";
import settings from "../../assets/pl/settings.webp";
import vouchers from "../../assets/pl/vouchers.webp";
import permissions from "../../assets/pl/permission.webp";
import job from "../../assets/pl/job_1.webp";

import { Link } from "react-router-dom";
import json from "./admin.json";
import { Project } from "../../components/project";
import { IoIosArrowForward } from "react-icons/io";

const imageMap = {
  active_users,
  chapter,
  company,
  courses,
  edit_course,
  emails,
  job,
  jobss,
  login,
  newsletter,
  settings,
  vouchers,
  permissions,
};

export const AdminPanel = () => {
  return (
    <div className="flex flex-col sm:items-start items-center text-primary gap-3 animate-fade-down animate-once animate-duration-1000 animate-delay-0 animate-ease-in-out animate-normal animate-fill-both">
      <Project json={json} imageMap={imageMap} />

      <div className="sm:text-[30px] text-[25px] font-[500] mt-3">
        Link to the project
      </div>
      <div className="flex text-secondary justify-center gap-x-4 text-xl">
        <IoIosArrowForward className="text-secondary mt-1" />
        <div>
          Please
          <Link to={"/contact"} className="text-xl italic text-secondary mx-1">
            contact me
          </Link>
          for further details
        </div>
      </div>
    </div>
  );
};
